import "./profileimg.css";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import CircularProgress from "@mui/material/CircularProgress";
import { useUploadMultipleMutation } from "../../../../features/upload/uploadApiSlice";
import { useDropzone } from "react-dropzone";
import { getAsset } from "../../../../helpers/helper";
import { FailedNotify, SuccessNotify } from "../../../../constants/tostify";
import { useLocation } from "react-router-dom";
import { useUpdateUserProfileMutation } from "../../../../features/user/userApiSlice";
import dummyUser from "../../../../assets/images/dummy/user-avatar-img.jpg";
import ImageCropDialog from "../../../../components/common/ImageCropDialog/ImageCropDialog";

const Profileimg = ({ infooo, name, setInfooo }) => {
  const location = useLocation();
  const [isUploading, setIsUploading] = useState(false);
  const [updateProfile] = useUpdateUserProfileMutation();
  const [uploadMultiple] = useUploadMultipleMutation();
  const [cropOpen, setCropOpen] = useState(false);
  const [pendingFile, setPendingFile] = useState(null);

  const onDrop = async (acceptedFiles) => {
    // Open crop dialog for the first selected file
    const file =
      acceptedFiles && acceptedFiles.length ? acceptedFiles[0] : null;
    if (file) {
      setPendingFile(file);
      setCropOpen(true);
    }
  };

  const handleCroppedAndUpload = async (blob) => {
    if (!blob || !pendingFile) return;
    setIsUploading(true);
    try {
      const croppedFile = new File([blob], pendingFile.name || "cropped.jpg", {
        type: blob.type,
      });
      const formData = new FormData();
      formData.append("images", croppedFile);

      const uploadRes = await uploadMultiple(formData).unwrap();

      if (uploadRes?.success || uploadRes?.message === "imagesSaved") {
        const extractImagePath = (f) => {
          if (!f) return null;
          if (typeof f === "string") {
            if (f.includes("undefined")) return null;
            return f.startsWith("/") ? f : "/images/" + f;
          }
          const fname = f?.filename || f?.name || (f?.url ? f.url.split("/").pop() : null);
          if (!fname || fname === "undefined") return null;
          return fname.startsWith("/") ? fname : "/images/" + fname;
        };

        const rawFiles = uploadRes?.file || uploadRes?.files || uploadRes?.urls || [];
        const abc = (Array.isArray(rawFiles) ? rawFiles : [rawFiles]).map(extractImagePath).filter(Boolean);

        const targetUserId = infooo?._id || name?._id;

        if (abc.length > 0 && targetUserId) {
          const response = await updateProfile({
            id: targetUserId,
            data: { imageUrl: abc },
          }).unwrap();

          if (response?.success) {
            SuccessNotify("Profile image updated!");
            if (response?.data?.User) {
              setInfooo(response.data.User);
              
              const imageUrl = abc?.[0] || response?.data?.User?.imageUrl?.[0] || null;
              if (imageUrl) {
                window.dispatchEvent(
                  new CustomEvent("image-upload-success", {
                    detail: {
                      userId: targetUserId,
                      imageUrl: imageUrl,
                      timestamp: new Date().toISOString(),
                    },
                  })
                );
              }
            }
          }
        } else {
          FailedNotify("Upload failed: invalid image response");
        }
      } else {
        FailedNotify("Upload failed");
      }
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setCropOpen(false);
      setPendingFile(null);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: { 'image/*': [] },
    onDrop,
    disabled: isUploading,
  });

  return (
    <>
      <div className="position_r">
        {/* Profile_dp keeps position:absolute from CSS — do NOT add inline position style here */}
        <div className="Profile_dp">
          <img
            src={
              (Array.isArray(infooo?.imageUrl) ? infooo.imageUrl[0] : infooo?.imageUrl)
                ? getAsset(Array.isArray(infooo.imageUrl) ? infooo.imageUrl[0] : infooo.imageUrl)
                : dummyUser
            }
            alt=""
            className="profile_img2"
            style={{ marginLeft: dummyUser && "-5px" }}
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = dummyUser;
            }}
          />
          {/* Spinner overlay — absolutely positioned inside the profile circle */}
          {isUploading && (
            <div className="profile-spinner-overlay">
              <CircularProgress size={36} style={{ color: "#3d3bee" }} />
            </div>
          )}
        </div>

        {location.pathname === "/user-profile" ? (
          <div className="P_camera">
            <label htmlFor="icon-button-file">
              <div {...getRootProps()} className="dropzone">
                <input {...getInputProps()} />
                <IconButton
                  color="primary"
                  component="span"
                  disabled={isUploading}
                >
                  <PhotoCameraIcon
                    style={{ color: "black" }}
                    className="icon_f"
                  />
                </IconButton>
              </div>
            </label>
          </div>
        ) : (
          ""
        )}
        <ImageCropDialog
          open={cropOpen}
          file={pendingFile}
          aspect={1}
          onClose={() => setCropOpen(false)}
          onCrop={handleCroppedAndUpload}
        />
      </div>
    </>
  );
};

export default Profileimg;
